module.exports = __webpack_public_path__ + "img/refresh.93882e92.svg";